import { isFreeTopic } from '../api/Courses'
import { buildRequestURL } from '../api'

/* =============================================
 * Public constants
 * ============================================= */

// Keys
const KEY_COURSE_ID = 'courseId'
const KEY_CHAT_TYPE = 'chatType'
const KEY_LESSON_ID = 'lessonId'
const KEY_TOPIC_ID = 'topicId'
const KEY_QUIZ_ID = 'quizId'
const KEY_AFFIRMATION_ID = 'affirmationId'
const KEY_COMPLIMENTS_ID = 'complimentsId'
const KEY_DATE_IDEAS_ID = 'dateIdeasId'
const KEY_COPINGSKILLS_ID = 'copingSkillsId'
const KEY_RELATIONSHIPQA_ID = 'conversationCategoryId'
const KEY_BREATHING_ID = 'breathingId'
const KEY_BREATHING_VIDEO_MINUTE = 'breathingVideoMinute'
const KEY_JOURNALING_ID = 'journalingId'
const KEY_INTRO_VIDEO = 'practiceType'
const KEY_MEDITATION_ID = 'meditationId'
const KEY_RESOURCE_ID = 'resourceId'
const KEY_REMBLE_DAILY = 'dailyRembleId'
const KEY_ARTICLE_ID = 'articleId'
const KEY_JOURNAL_ENTRY_ID = 'journalEntryId'
const KEY_PRACTICE_ID = 'practiceId'
const KEY_CATEGORY = 'categoryId'

// Routes
const ROUTE_ACTIVITIES_ALL = '/practices'

// Assessments and Programs
const ROUTE_ASSESSMENT = '/assessment'
const ROUTE_ASSESSMENT_COMPLETE = `${ROUTE_ASSESSMENT}/complete`
const ROUTE_ASSESSMENT_PROGRAM = `${ROUTE_ASSESSMENT}/program`

const ROUTE_ACTIVITIES_COMPLIMENTS_ALL = `${ROUTE_ACTIVITIES_ALL}/compliments`
const ROUTE_ACTIVITIES_COMPLIMENTS = `${ROUTE_ACTIVITIES_COMPLIMENTS_ALL}/:${KEY_COMPLIMENTS_ID}`
const ROUTE_ACTIVITIES_DATE_IDEAS_ALL = `${ROUTE_ACTIVITIES_ALL}/date-ideas`
const ROUTE_ACTIVITIES_DATE_IDEAS = `${ROUTE_ACTIVITIES_DATE_IDEAS_ALL}/:${KEY_DATE_IDEAS_ID}`

const ROUTE_ACTIVITIES_AFFIRMATIONS_ALL = `${ROUTE_ACTIVITIES_ALL}/affirmations`
const ROUTE_ACTIVITIES_AFFIRMATIONS = `${ROUTE_ACTIVITIES_AFFIRMATIONS_ALL}/:${KEY_AFFIRMATION_ID}`
const ROUTE_ACTIVITIES_AFFIRMATIONS_BUILDER = `${ROUTE_ACTIVITIES_AFFIRMATIONS_ALL}/builder`

const ROUTE_ACTIVITIES_COPINGSKILLS_ALL = `${ROUTE_ACTIVITIES_ALL}/coping-skills`
const ROUTE_ACTIVITIES_COPINGSKILL_INTRO = `${ROUTE_ACTIVITIES_COPINGSKILLS_ALL}/intro/:${KEY_COPINGSKILLS_ID}`
const ROUTE_ACTIVITIES_COPINGSKILL = `${ROUTE_ACTIVITIES_COPINGSKILLS_ALL}/:${KEY_COPINGSKILLS_ID}/practice`

const ROUTE_ACTIVITIES_RELATIONSHIPQA_ALL = `${ROUTE_ACTIVITIES_ALL}/relationship-conversations`
const ROUTE_ACTIVITIES_RELATIONSHIPQA = `${ROUTE_ACTIVITIES_RELATIONSHIPQA_ALL}/:${KEY_RELATIONSHIPQA_ID}`

const ROUTE_ACTIVITIES_BREATHING_ALL = `${ROUTE_ACTIVITIES_ALL}/breathing`
const ROUTE_ACTIVITIES_BREATHING_INTRO = `${ROUTE_ACTIVITIES_BREATHING_ALL}/intro/:${KEY_BREATHING_ID}`
const ROUTE_ACTIVITIES_BREATHING = `${ROUTE_ACTIVITIES_BREATHING_ALL}/:${KEY_BREATHING_ID}/breath/:${KEY_BREATHING_VIDEO_MINUTE}`

const ROUTE_ACTIVITIES_JOURNALING_ALL = `${ROUTE_ACTIVITIES_ALL}/journaling`
const ROUTE_ACTIVITIES_JOURNALING = `${ROUTE_ACTIVITIES_JOURNALING_ALL}/:${KEY_JOURNALING_ID}`
const ROUTE_ACTIVITIES_JOURNALING_DAILY_ALL = `${ROUTE_ACTIVITIES_JOURNALING_ALL}/daily`
const ROUTE_ACTIVITIES_JOURNALING_DAILY = `${ROUTE_ACTIVITIES_JOURNALING_ALL}/daily/:${KEY_JOURNALING_ID}`
const ROUTE_ACTIVITIES_JOURNALING_CREATE_JOURNAL = `${ROUTE_ACTIVITIES_JOURNALING_ALL}/create-journal`
const ROUTE_ACTIVITIES_JOURNALING_SAVED_JOURNAL_ALL = `${ROUTE_ACTIVITIES_JOURNALING_ALL}/list-journal`
const ROUTE_ACTIVITIES_JOURNALING_SAVED_JOURNAL = `${ROUTE_ACTIVITIES_JOURNALING_SAVED_JOURNAL_ALL}/:${KEY_JOURNALING_ID}`
const ROUTE_ACTIVITIES_JOURNALING_EDIT_SAVED_JOURNAL = `${ROUTE_ACTIVITIES_JOURNALING_DAILY}/:${KEY_JOURNAL_ENTRY_ID}`

// MEDITATIONS
const ROUTE_ACTIVITIES_MEDITATION_ALL = `${ROUTE_ACTIVITIES_ALL}/meditations`
const ROUTE_ACTIVITIES_CUSTOM_MEDITATE = `${ROUTE_ACTIVITIES_ALL}/meditations/meditate`
const ROUTE_ACTIVITIES_MEDITATION = `${ROUTE_ACTIVITIES_MEDITATION_ALL}/intro/:${KEY_MEDITATION_ID}`
const ROUTE_ACTIVITIES_MEDITATE = `${ROUTE_ACTIVITIES_MEDITATION_ALL}/:${KEY_MEDITATION_ID}/meditate`

const ROUTE_ACTIVITY_BASE = `${ROUTE_ACTIVITIES_ALL}/introduction-video`

const ROUTE_ACTIVITY_INTRO_VIDEO = `${ROUTE_ACTIVITY_BASE}/:${KEY_INTRO_VIDEO}`
const ROUTE_PRACTICE_INTRO_VIDEO = `${ROUTE_ACTIVITIES_ALL}/why/:${KEY_INTRO_VIDEO}`

const ROUTE_SEARCH = '/search'
const ROUTE_SUPPORT = '/support'
const ROUTE_NOTIFICATIONS = '/notifications'
const ROUTE_NOTIFICATIONS_PRACTICES = `/notifications/:${KEY_PRACTICE_ID}`
const ROUTE_SUPPORT_RESOURCES = `${ROUTE_SUPPORT}/resources/:${KEY_RESOURCE_ID}`

const ROUTE_ARTICLES_BASE = `/articles`
const ROUTE_ARTICLES = `${ROUTE_ARTICLES_BASE}/:${KEY_ARTICLE_ID}`
const ROUTE_ARTICLES_ALL = ROUTE_ARTICLES_BASE

const ROUTE_COURSES_ALL = '/courses'
const ROUTE_COURSES = `${ROUTE_COURSES_ALL}/:${KEY_COURSE_ID}`
const ROUTE_LESSONS = `${ROUTE_COURSES}/lessons/:${KEY_LESSON_ID}`
const ROUTE_TOPICS = `${ROUTE_LESSONS}/topics/:${KEY_TOPIC_ID}`
const ROUTE_QUIZZES = `${ROUTE_TOPICS}/quizzes/:${KEY_QUIZ_ID}`

const ROUTE_LIBRARY = '/library'
const ROUTE_CATEGORY = `/category/:${KEY_CATEGORY}`

const ROUTE_CHAT_GENERAL = '/chat'
const ROUTE_CHAT = `${ROUTE_CHAT_GENERAL}/:${KEY_CHAT_TYPE}`

const ROUTE_FORGOT_PASSWORD = '/forgot-password'
const ROUTE_LOGIN = '/login'
const ROUTE_LOGIN_PRIVATE = '/_login'
const ROUTE_LOGIN_OAUTH = '/oauth'
const ROUTE_LOGIN_OAUTH_OPENID = '/oauth/openid'
const ROUTE_LOGOUT = '/logout'
const ROUTE_MEMBERSHIP = '/membership'
const ROUTE_PAYMENTS = '/payments'
const ROUTE_PAYMENTS_COMPLETE = `${ROUTE_PAYMENTS}/complete`
const ROUTE_PAYMENTS_DETAILS = `${ROUTE_PAYMENTS}/details`
const ROUTE_PROFILE = '/profile'
const ROUTE_SUBSCRIPTION = '/subscription'
const ROUTE_SUBSCRIPTION_CANCEL = `${ROUTE_SUBSCRIPTION}/cancel`
const ROUTE_SIGNUP = '/signup'
const ROUTE_TODAY = '/today'
const ROUTE_BOOKMARKS = '/bookmarks'
const ROUTE_HISTORY = '/history'
const ROUTE_VERIFY = `/verify`
const ROUTE_WELCOME = '/welcome'
const ROUTE_TOS_ACCEPTANCE = '/tos-acceptance'
const ROUTE_DAILY_REMBLE = `${ROUTE_TODAY}/daily-remble`
const ROUTE_DAILY_REMBLE_VIDEO = `${ROUTE_DAILY_REMBLE}/:${KEY_REMBLE_DAILY}`

// check-in
const ROUTE_CHECK_IN = '/check-in'
const ROUTE_CHECK_IN_SUMMARY = '/check-in/summary'

/* =============================================
 * Public methods
 * ============================================= */

/**
 * Returns the url path to a topic with the passed in Course, Lesson, Topic IDs, type, and course locked status
 * @param {boolean} courseIsLocked Whether or not the course is locked
 * @param {Number} courseId The course ID of the course to which the lesson belongs
 * @param {Number} lessonId The ID of the Lesson the topic belongs to
 * @param {Number} topic The Topic to load
 * @param {boolean} autoplay Whether or not the course should autoplay
 */
const getTopicUrl = (
  courseIsLocked,
  courseId,
  lessonId,
  topic,
  autoplay = false
) => {
  // If the course or topic is locked, then don't allow the user to navigate to it
  if (courseIsLocked && !isFreeTopic(topic)) {
    const returnPath = getCoursePath(courseId)

    // Return early
    return buildRequestURL(ROUTE_PAYMENTS, { returnPath })
  }

  // Otherwise, navigate to the topic
  return getTopicPath(courseId, lessonId, topic.id) + '?autoplay=' + autoplay
}

/**
 * Returns the url path to a course with the given courseId
 * @param {Number} courseId The ID of the course
 */
const getCoursePath = courseId => `${ROUTE_COURSES_ALL}/${courseId}`

/**
 * Returns the url path to a lesson with the given courseId and lessonId
 * @param {Number} courseId The ID of the course
 * @param {Number} lessonId The ID of the lesson
 */
const getLessonPath = (courseId, lessonId) =>
  `${ROUTE_LESSONS}`
    .replaceAll(`:${KEY_COURSE_ID}`, courseId)
    .replaceAll(`:${KEY_LESSON_ID}`, lessonId)

/**
 * Returns the url path to a topic with the given courseId, lessonId, and topicId
 * @param {Number} courseId The ID of the course
 * @param {Number} lessonId The ID of the lesson
 * @param {Number} topicId The ID of the topic
 */
const getTopicPath = (courseId, lessonId, topicId) =>
  `${ROUTE_TOPICS}`
    .replaceAll(`:${KEY_COURSE_ID}`, courseId)
    .replaceAll(`:${KEY_LESSON_ID}`, lessonId)
    .replaceAll(`:${KEY_TOPIC_ID}`, topicId)

/**
 * Returns the url path to a quiz with the given courseId, lessonId, topicId, and quizId
 * @param {Number} courseId The ID of the course
 * @param {Number} lessonId The ID of the lesson
 * @param {Number} topicId The ID of the topic
 * @param {Number} quizId The ID of the quiz
 */
const getQuizPath = (courseId, lessonId, topicId, quizId) =>
  `${ROUTE_QUIZZES}`
    .replaceAll(`:${KEY_COURSE_ID}`, courseId)
    .replaceAll(`:${KEY_LESSON_ID}`, lessonId)
    .replaceAll(`:${KEY_TOPIC_ID}`, topicId)
    .replaceAll(`:${KEY_QUIZ_ID}`, quizId)

const getSegments = () => window.location.pathname.split('/').filter(Boolean)

const getSegment = (index = 0) => getSegments()[index]

//routes
export {
  KEY_COURSE_ID,
  KEY_INTRO_VIDEO,
  KEY_AFFIRMATION_ID,
  KEY_COMPLIMENTS_ID,
  KEY_DATE_IDEAS_ID,
  KEY_RELATIONSHIPQA_ID,
  KEY_JOURNALING_ID,
  KEY_RESOURCE_ID,
  KEY_CHAT_TYPE,
  ROUTE_CHAT,
  ROUTE_CHAT_GENERAL,
  ROUTE_COURSES,
  ROUTE_COURSES_ALL,
  ROUTE_LESSONS,
  ROUTE_TOPICS,
  ROUTE_SEARCH,
  ROUTE_QUIZZES,
  ROUTE_LOGIN,
  ROUTE_LOGIN_PRIVATE,
  ROUTE_LOGIN_OAUTH,
  ROUTE_LOGIN_OAUTH_OPENID,
  ROUTE_LOGOUT,
  ROUTE_MEMBERSHIP,
  ROUTE_PAYMENTS,
  ROUTE_PAYMENTS_COMPLETE,
  ROUTE_PAYMENTS_DETAILS,
  ROUTE_SIGNUP,
  ROUTE_ACTIVITIES_ALL,
  ROUTE_ASSESSMENT,
  ROUTE_ASSESSMENT_COMPLETE,
  ROUTE_ASSESSMENT_PROGRAM,
  ROUTE_ACTIVITIES_COMPLIMENTS_ALL,
  ROUTE_ACTIVITIES_COMPLIMENTS,
  ROUTE_ACTIVITIES_DATE_IDEAS,
  ROUTE_ACTIVITIES_DATE_IDEAS_ALL,
  ROUTE_ACTIVITIES_AFFIRMATIONS,
  ROUTE_ACTIVITIES_AFFIRMATIONS_ALL,
  ROUTE_ACTIVITIES_AFFIRMATIONS_BUILDER,
  ROUTE_ACTIVITIES_RELATIONSHIPQA,
  ROUTE_ACTIVITIES_RELATIONSHIPQA_ALL,
  ROUTE_ACTIVITIES_BREATHING,
  ROUTE_ACTIVITIES_BREATHING_ALL,
  ROUTE_ACTIVITIES_BREATHING_INTRO,
  ROUTE_ACTIVITIES_JOURNALING_ALL,
  ROUTE_ACTIVITY_INTRO_VIDEO,
  ROUTE_ACTIVITIES_MEDITATION_ALL,
  ROUTE_ACTIVITIES_CUSTOM_MEDITATE,
  ROUTE_ACTIVITIES_MEDITATION,
  ROUTE_ACTIVITIES_MEDITATE,
  ROUTE_ACTIVITIES_JOURNALING,
  ROUTE_ACTIVITIES_JOURNALING_DAILY,
  ROUTE_ACTIVITIES_JOURNALING_DAILY_ALL,
  ROUTE_ACTIVITIES_JOURNALING_CREATE_JOURNAL,
  ROUTE_ACTIVITIES_JOURNALING_SAVED_JOURNAL_ALL,
  ROUTE_ACTIVITIES_JOURNALING_SAVED_JOURNAL,
  ROUTE_ACTIVITIES_COPINGSKILLS_ALL,
  ROUTE_ACTIVITIES_COPINGSKILL,
  ROUTE_ACTIVITIES_COPINGSKILL_INTRO,
  ROUTE_FORGOT_PASSWORD,
  ROUTE_TODAY,
  ROUTE_BOOKMARKS,
  ROUTE_HISTORY,
  ROUTE_VERIFY,
  ROUTE_WELCOME,
  ROUTE_TOS_ACCEPTANCE,
  ROUTE_PRACTICE_INTRO_VIDEO,
  ROUTE_SUBSCRIPTION,
  ROUTE_SUBSCRIPTION_CANCEL,
  ROUTE_PROFILE,
  ROUTE_SUPPORT,
  ROUTE_SUPPORT_RESOURCES,
  ROUTE_DAILY_REMBLE,
  ROUTE_DAILY_REMBLE_VIDEO,
  ROUTE_ARTICLES_BASE,
  ROUTE_ARTICLES,
  ROUTE_ARTICLES_ALL,
  ROUTE_NOTIFICATIONS,
  ROUTE_NOTIFICATIONS_PRACTICES,
  ROUTE_ACTIVITIES_JOURNALING_EDIT_SAVED_JOURNAL,
  ROUTE_CHECK_IN,
  ROUTE_CHECK_IN_SUMMARY,
  ROUTE_LIBRARY,
  ROUTE_CATEGORY,
  KEY_CATEGORY,
  getCoursePath,
  getLessonPath,
  getTopicPath,
  getTopicUrl,
  getQuizPath,
  getSegment,
  getSegments
}
